// @flow

import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { fontNormal } from "../../_static/Typography";

export const RunnerOddsContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ isInlinePP }) =>
    isInlinePP &&
    css`
      padding-left: 12px;
      border: 1px solid ${buildColor("blue", "100")};
      border-bottom: none;
    `}
`;

export const OddsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
  font-family: ${fontNormal};
  font-size: 14px;
  color: ${buildColor("grey", "700")};
  height: 20px;
  line-height: 20px;
`;

export const MorningOdds = styled.span`
  margin-right: 16px;
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin-top: 8px;
`;

export const Comment = styled.span`
  font-family: ${fontNormal};
  font-size: 14px;
  color: ${buildColor("grey", "800")};
  line-height: 18px;
`;

export const SilkContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 12px;
`;

export const Silk = styled.img`
  height: 46px;
  width: 46px;
`;

export const Odd = styled.span`
  display: flex;
  align-items: center;

  &:last-child {
    color: ${buildColor("grey", "800")};
  }
`;

export const RunnerOddsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
